export default __webpack_public_path__ + "static/media/widget.c657563b.svg";